module.exports = __webpack_public_path__ + "media/images/icon_room_owner-f06fcb35e80823f0dd82ac3ebf3491f2.svg";